module.exports = __webpack_public_path__ + "img/email.04ce27f4.svg";